module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_5012.634bf6bf.png";